export * from './home'
export * from './how-it-works'
export * from './faq'
export * from './iota'
export * from './donations'
export * from './privacy'
export * from './wallet'
export * from './buy'
